const parserOptionsListingFeature = (options) => {
  return options.map((item) => ({
    value: item.id,
    label: `$${item.price}`, // Format price with a dollar sign
    description: `${item.durationInDays} days`
  }));
};

const parserOptionsListingExpand = (options) => {
  return options.map((item) => ({
    value: item.id,
    label: `$${item.price}/unlimited time`, // Format price with a dollar sign
    description: `${item.addedListingLimit} Listing`
  }));
};
const parseListingExpandPlan = (options) => {
  return options.map((item) => ({
    price: item.price, // Format price with a dollar sign
    listings: item.addedListingLimit
  }));
};

const parseCurrencyObjectToOptions = (keys) => {
  return Object.keys(keys).map((key) => ({
    label: `${keys[key]?.targetCurrencySymbol ?? "-"} ${
      keys[key]?.targetCurrencyCode ?? "-"
    }`,
    value: key
  }));
};

export {
  parserOptionsListingFeature,
  parserOptionsListingExpand,
  parseListingExpandPlan,
  parseCurrencyObjectToOptions
};
